import { Form } from "react-bootstrap";
import "./builder.css";
import { CAUSE_OPTIONS } from "../constants/causes";
import type { ChangeOrderCause } from "../constants/causes";

export interface CauseRadiosProps {
  id: string;
  value: ChangeOrderCause | "";
  onChange: (cause: ChangeOrderCause) => void;
  error?: string;
  disabled?: boolean;
}

const CauseRadios = ({ id, value, onChange, error, disabled = false }: CauseRadiosProps) => (
  <Form.Group className="mb-3" role="radiogroup" aria-labelledby={`${id}-cause-label`}>
    <Form.Label id={`${id}-cause-label`}>Why is the scope changing?</Form.Label>
    <div className="changeOrderCauseOptions">
      {CAUSE_OPTIONS.map((opt) => (
        <Form.Check
          key={opt.value}
          type="radio"
          className={`changeOrderCauseOption${value === opt.value ? " selected" : ""}`}
          id={`${id}-cause-${opt.value}`}
          name={`${id}-cause`}
          label={opt.label}
          checked={value === opt.value}
          disabled={disabled}
          onChange={() => onChange(opt.value)}
        />
      ))}
    </div>
    {error && <Form.Text className="text-danger">{error}</Form.Text>}
  </Form.Group>
);

export default CauseRadios;
